import debug from "debug";

const log = debug("required-field");

function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

const validators = {
	'at_least_one_checked': (inputs) => {
		return inputs.filter((input) => {
			return input.checked;
		}).length > 0 ? '' : 'check at least one';
	}
};

class RequiredField {
	constructor(element, options) {
		log("element", element);
		log("options", options);

		this.options = options;
		this.element = element;

		this.isFieldset = this.element.nodeName === 'FIELDSET';

		this.inputSet = [...this.element.querySelectorAll(
			`[name="${this.options.inputSet}"]`
		)];

		this.input = this.element.querySelector(
			`[name="${this.options.name}"]`
		);

		this.errorElementSelectorScope =
			this.options.errorSelector[0] === "#" ? document : this.element;

		this.errorElement = this.errorElementSelectorScope.querySelector(
			this.options.errorSelector
		);

		this.showErrors = getJSONValue(this.element.dataset.showErrors);

		this.attributeObserver = new MutationObserver(
			this.onAttributeChange.bind(this)
		);

		if (!this.input && !this.isFieldset) {
			log('Provide either a fieldset with inputs or an input. Aborting');
			return false;
		}

		this.init();
		this.watch();

		log("ready", this, this.element);
	}

	init() {
		this.updateValue();
	}

	watch() {
		log("watching");
		this.element.addEventListener("change", this.updateValue.bind(this));
		this.attributeObserver.observe(this.element, { attributes: true });
	}

	isValid() {
		// Presuming this.element is a fieldset
		const elementToValidate = this.input || this.element;
		return elementToValidate.validity.valid;
	}

	updateFieldsetValidity() {
		const validator = validators[this.options.rule];
		if (!this.isFieldset || !validator) {
			return false;
		}

		this.element.setCustomValidity(validator(this.inputSet));
	}

	updateErrorMessage() {
		this.errorElement.hidden = this.isValid();
	}

	updateValue() {
		this.updateFieldsetValidity();

		if (this.showErrors) {
			this.updateErrorMessage();
		}
	}

	onAttributeChange(mutationList, observer) {
		mutationList
			.filter(
				function(mutation) {
					return (
						mutation.type === "attributes" &&
						mutation.attributeName ===
							this.options.componentErrorAttribute
					);
				}.bind(this)
			)
			.forEach(this.onShowErrorsChange.bind(this));
	}

	onShowErrorsChange(mutation) {
		this.showErrors = getJSONValue(this.element.dataset.showErrors);
		this.updateErrorMessage();
	}
}

RequiredField.DEFAULTS = {
	componentErrorAttribute: "data-show-errors"
};

export default RequiredField;



// WEBPACK FOOTER //
// ./project/client/src/core/components/required-field/required-field.js